/**
 * A Zoho Books record as a new-tab link (#1035). When no Books id is stored the label stays text:
 * the link is omitted rather than pointed at a guessed URL.
 */
import { ExternalLink } from 'lucide-react'
import type * as React from 'react'
import { safeHref } from '../lib/safeUrl'

export function BooksRecordLink({
  href,
  label,
  children,
  className,
}: {
  href?: string | null
  /** Accessible name, for example "Open PO-06465 in Books". */
  label: string
  children: React.ReactNode
  className?: string
}) {
  const safe = safeHref(href)
  if (!safe) return <span className={className ?? 'font-medium'}>{children}</span>
  return (
    <a
      href={safe}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className={className ?? 'inline-flex items-center gap-1 font-medium text-primary underline underline-offset-2'}
      onClick={(event) => event.stopPropagation()}
    >
      {children}
      <ExternalLink className="size-3.5 shrink-0" aria-hidden />
    </a>
  )
}
